import { setLoadingBar } from '../../../Project/bavaria-no/RouteHandler';
import { LIST_CACHE_EXPIRY_TIME } from '../../../Project/bavaria-no/constants';
import {
  GET_TOTAL_COUNT,
  UPDATE_CURRENT_QUERY,
  UPDATE_CARS,
  UPDATE_CARS_TIMESTAMP,
  UPDATE_TOTAL_COUNT,
  GET_CARS,
  GET_CARS_TIMESTAMP,
} from '../actions/types';
import { scrollToSavedPosition } from './scrollPosition';
import { combineQueries } from './combineQueries';
import { fetchFilterItems } from './fetchFilterItems';

export const getDynamicCarFilterItems = ({
  queryParams,
  perPage,
  filterActions,
  currentQuery,
  eventType,
  pageNumber = 0,
  vehicleType,
  argSorting,
}) => {
  const filterType = 'Car';
  const newVehicleType = vehicleType ? vehicleType : 'PB';
  const query = combineQueries(
    `&tg=${newVehicleType}&so=${argSorting ? argSorting : 'lr'}`,
    queryParams
  );

  const carsTimeStamp = filterActions(GET_CARS_TIMESTAMP, null, { filterType });
  const currentCars = filterActions(GET_CARS, null, { filterType });
  const totalCount = filterActions(GET_TOTAL_COUNT, null, { filterType });
  const isCacheExpired = new Date() - carsTimeStamp > LIST_CACHE_EXPIRY_TIME;
  const isPagination = eventType === 'PAGINATE';
  const isFilter = eventType === 'FILTER';
  const isSorting = eventType === 'SORT';

  if (currentCars.length === 0 || isCacheExpired || currentQuery !== query) {
    if (!isPagination) {
      filterActions(UPDATE_CARS_TIMESTAMP, null, { filterType });
    }
    if (!isFilter && !isPagination) {
      filterActions(UPDATE_CARS, [], { filterType });
    }

    return fetchFilterItems({
      filterType,
      perPage,
      pageNumber,
      query,
      resetScrollPosition: !isSorting,
    }).then((res) => {
      filterActions(UPDATE_CURRENT_QUERY, query, { filterType });
      const cars = isPagination ? [...currentCars, ...res?.cars] : [...res?.cars];
      filterActions(UPDATE_CARS, cars, { filterType });
      if (res?.totalCount) {
        filterActions(UPDATE_TOTAL_COUNT, Number(res?.totalCount), { filterType });
      }
      return res;
    });
  }

  filterActions(UPDATE_CURRENT_QUERY, query, { filterType });

  scrollToSavedPosition();
  return new Promise((resolve) => {
    resolve({
      cars: currentCars,
      pageNumber: pageNumber,
      perPage,
      totalCount: totalCount,
    });
  });
};
